module.exports = __webpack_public_path__ + "static/media/bo.55513548.jpg";